import * as React from 'react';
import * as classNames from 'classnames';
import { TabInfo } from '../../reducers/pages'; // FIXME : Probably this reference is a bad idea.
import { getBasePath } from '../../utils/browser';

interface TabProps {
  active: boolean;
  title: string;
  onClick: () => void;
  onClose: () => void;
}

const Tab: React.SFC<TabProps> = (props) => {
  const iconImage = props.active ? 'tab-active' : 'tab-inactive';
  const closeButtonImage = props.active ? 'tab-close-active' : 'tab-close-inactive';
  const baseDir = getBasePath();

  const style: React.CSSProperties = {
    marginLeft: '1px',
    width: '140px',
    height: props.active ? '44px' : '40px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: props.active ? '#fff' : '#99978d',
    backgroundImage: `url(${baseDir}/images/tabbar/${iconImage}.png)`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '5px center',
    backgroundSize: '22px',
  };

  const textStyle: React.CSSProperties = {
    paddingLeft: '30px',
    flexGrow: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
    color: props.active ? '#1a2d78' : '#fff',
  };
  const closeStyle: React.CSSProperties = {
    flexShrink: 0,
    width: '13px',
    height: '13px',
    margin: '0 10px 0 5px',
  };

  return (
    <div style={style} onClick={props.onClick} className={classNames({ active: props.active })}>
      <span style={textStyle} title={props.title} >
        {props.title}
      </span>
      <img
        style={closeStyle}
        src={`${baseDir}/images/tabbar/${closeButtonImage}.png`}
        aria-label="Close"
        onClick={(ev) => { ev.stopPropagation(); props.onClose(); }} />
    </div>
  );
};

export interface TabbarProps {
  tabs: ReadonlyArray<TabInfo>;
  activeTabIndex: number; // XXX : Should this be key instead of index?
  onSelect: (index: number) => void;
  onCloseButtonClick: (index: number) => void;
}

const tabbarStyle: React.CSSProperties = {
  height: '48px',
  backgroundColor: '#666666',
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'left',
  flexWrap: 'nowrap',
  boxSizing: 'border-box',
  paddingLeft: '64px',
};

export const Tabbar: React.SFC<TabbarProps> = (props) => {
  const tabs = props.tabs.map((tab, index) => {
    const active = index === props.activeTabIndex;
    const select = () => props.onSelect(index);
    const close = () => props.onCloseButtonClick(index);

    return (
      <Tab
        key={index}
        active={active}
        onClick={select}
        onClose={close}
        title={tab.title} />
    );
  });

  return <div id="viewer-tab-bar" style={tabbarStyle}>{tabs}</div>;
};
